import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetohyderabadcabs() {



  const cardData =
  {
    keyword: 'Pune to Hyderabad Cabs',
    heading: 'Sai Trupti Cabs: Pune to Hyderabad Cabs',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune to Hyderabad cab hire services, designed to make your long-distance journey smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors and ample luggage space. Every journey is driven by a professional, background-verified chauffeur who ensures punctual pickup in Pune, courteous service, and safe, smooth driving all the way to Hyderabad. With transparent one-way fares, flexible booking options (one-way or round-trip), and 24×7 customer support, Sai Trupti Cabs makes your travel from Pune to Hyderabad convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Hyderabad with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Charminar",
    "description": "Charminar, the iconic heart of Hyderabad, stands as a timeless symbol of the city’s architectural grace and cultural unity. Built in 1591 by Sultan Muhammad Quli Qutb Shah, the four minarets rise 56 meters into the sky, overlooking a labyrinth of bazaars and mosques. The surrounding Laad Bazaar shimmers with pearls, bangles, and aromas of Irani chai. Visitors climb its spiral staircase for panoramic views of the old city — a mesmerizing mix of domes, lights, and heritage. Whether visited by day or lit up at night, Charminar remains the soul of Hyderabad — elegant, historic, and ever alive."
  },
  {
    "title": "Golconda Fort",
    "description": "Golconda Fort is Hyderabad’s majestic guardian, echoing tales of diamonds, dynasties, and defiance. Once home to the world-famous Kohinoor and Golconda diamonds, this 13th-century fortress showcases ingenious acoustics, grand gateways, and royal chambers. The climb to the summit rewards visitors with sweeping views of the city and its shimmering skyline. Every evening, a captivating light-and-sound show brings the fort’s history to life against its stone walls. The rhythmic echoes of claps under the Fateh Darwaza still amaze tourists with their precision engineering. Golconda is where Hyderabad’s royal past meets its unbreakable pride."
  },
  {
    "title": "Ramoji Film City",
    "description": "Ramoji Film City, spread across 2,000 acres, holds the Guinness World Record as the largest film studio complex in the world. It’s a cinematic wonderland where visitors step into a world of sets, streets, and stories. From recreations of foreign cities to vintage trains and royal palaces, every corner is a filmmaker’s dream. The guided tours reveal behind-the-scenes magic, while live stunt shows and theme rides entertain families and kids alike. At night, the entire complex transforms into a dazzling festival of lights. Ramoji Film City captures the grandeur of Indian cinema and the imagination of every traveler."
  },
  {
    "title": "Hussain Sagar Lake & Buddha Statue",
    "description": "Hussain Sagar Lake, built in 1562, connects Hyderabad and Secunderabad like a shimmering heart of serenity. At its center stands the monolithic Buddha statue — 18 meters tall and carved from a single white granite rock. Ferry rides across the lake at sunset are mesmerizing as city lights reflect like jewels on the water. The surrounding Necklace Road, Lumbini Park, and Eat Street make it a lively leisure hub. Couples, families, and photographers flock here to capture the perfect skyline. Hussain Sagar is where tranquility floats amid urban sparkle, reflecting Hyderabad’s balance of peace and progress."
  },
  {
    "title": "Chowmahalla Palace",
    "description": "Chowmahalla Palace, the former seat of the Nizams, radiates royal splendor and timeless elegance. The palace complex, modeled after the Shah of Iran’s palace, features grand courtyards, fountains, and the magnificent Durbar Hall with its glittering chandeliers. The fusion of Persian, Indo-Saracenic, and European styles speaks volumes of Hyderabad’s cosmopolitan past. Vintage cars, regal costumes, and antiques displayed here narrate the luxurious lifestyle of the Nizams. A stroll through its marble corridors and lush gardens feels like a journey through time. Chowmahalla Palace is the crown jewel of Hyderabad’s regal heritage."
  },
  {
    "title": "Salar Jung Museum",
    "description": "Salar Jung Museum is one of India’s largest art museums, home to the rare private collection of Nawab Mir Yousuf Ali Khan (Salar Jung III). Spanning civilizations and centuries, the museum’s 40 galleries exhibit sculptures, paintings, clocks, textiles, manuscripts, and arms. Highlights include the mesmerizing Veiled Rebecca statue, the Double Statue of Mephistopheles and Margaretta, and ancient clocks that charm visitors every hour. Walking through its vast halls feels like a world tour of art and history. Salar Jung Museum transforms curiosity into awe — every artifact whispers a story of culture and craftsmanship."
  },
  {
    "title": "Birla Mandir",
    "description": "Perched atop Naubat Pahad hill, Birla Mandir stands as a gleaming marble tribute to Lord Venkateswara. Built entirely from white Rajasthani marble, it combines North and South Indian architectural styles. The temple offers sweeping views of Hyderabad city and Hussain Sagar Lake, especially enchanting at sunset. The serenity within contrasts beautifully with the city’s lively hum below. Devotees and tourists alike are drawn by its divine aura and panoramic setting. When illuminated at night, Birla Mandir glows like a celestial beacon of peace and purity amid the bustling metropolis."
  },
  {
    "title": "Qutb Shahi Tombs",
    "description": "The Qutb Shahi Tombs, located near Golconda Fort, form one of Hyderabad’s most majestic necropolises. These domed granite mausoleums house the remains of the seven rulers of the Qutb Shahi dynasty. Each tomb stands as a masterpiece of Persian and Deccan architecture, surrounded by landscaped gardens and lotus ponds. Intricate stucco work, pointed arches, and vast corridors showcase the era’s artistic brilliance. The quiet atmosphere evokes deep reflection, far removed from the city’s rush. The tombs not only honor royal lineage but also preserve the poetic soul of medieval Hyderabad."
  },
  {
    "title": "Nehru Zoological Park",
    "description": "Nehru Zoological Park, spread over 380 acres near Mir Alam Tank, is one of India’s most well-maintained zoos. It’s home to over 1,500 species, including tigers, elephants, rhinos, giraffes, and rare birds. Safari rides through lion and deer enclosures thrill children and adults alike. The reptile house, butterfly park, and aquarium add more wonder to the experience. Families often spend an entire day picnicking in its green zones and boating on the lake. The zoo combines education, adventure, and conservation — making it a joyful oasis for all age groups in Hyderabad."
  },
  {
    "title": "Mecca Masjid",
    "description": "Mecca Masjid, one of India’s oldest and largest mosques, stands near Charminar as a masterpiece of Mughal grandeur. Commissioned in 1614 by Sultan Muhammad Quli Qutb Shah, its central arch was built using soil from Mecca, lending it sacred significance. The mosque can accommodate over 10,000 worshippers, with intricately carved arches and granite columns hewn from single stones. The vast courtyard and calm reflection pond add to its majesty. During prayer times, the atmosphere fills with spiritual devotion and timeless grace. Mecca Masjid is a place where faith and history coexist in divine harmony."
  }
],



"services": [
  {
    "name": "Pune to Hyderabad Cabs",
    "description": "Book comfortable Pune to Hyderabad cabs for a long-distance, hassle-free journey. Choose from AC and non-AC vehicles including Sedans, SUVs, and luxury cars. Enjoy professional drivers experienced in interstate travel, flexible pickup and drop points, and transparent pricing. Ideal for family trips, weekend getaways, group travel, or corporate travel, with easy online booking, instant confirmation, and 24/7 customer support for a safe and enjoyable ride."
  },
  {
    "name": "Pune to Hyderabad Taxi Service",
    "description": "Hire a Pune to Hyderabad taxi for a smooth, stress-free ride. Travel in well-maintained vehicles with courteous and professional drivers. Flexible schedules, one-way or round-trip options, and transparent fare policies make it ideal for tourists, business travelers, and families seeking comfort and convenience."
  },
  {
    "name": "Pune to Hyderabad Car Hire",
    "description": "Rent a car from Pune to Hyderabad for personalized travel. Choose from Sedans, SUVs, and luxury cars, with AC/non-AC options. Benefit from professional drivers, luggage assistance, flexible routes, and safe travel. Perfect for families, groups, or business trips seeking comfort and reliability."
  },
  {
    "name": "AC Cab Pune to Hyderabad",
    "description": "Travel in comfort with AC cab service from Pune to Hyderabad. Enjoy air-conditioned vehicles, skilled drivers, flexible pickups, and smooth travel. Suitable for families, couples, and solo travelers looking for a relaxing long-distance journey."
  },
  {
    "name": "Non AC Cab Pune to Hyderabad",
    "description": "Affordable non-AC cab service from Pune to Hyderabad for budget-conscious travelers. Reliable drivers, well-maintained cars, and flexible pickup/drop points ensure safe, comfortable, and cost-effective long-distance travel."
  },
  {
    "name": "Innova Cab Pune to Hyderabad",
    "description": "Book spacious and comfortable Innova cabs from Pune to Hyderabad. Ideal for families or groups, featuring AC comfort, ample legroom, luggage space, and experienced drivers. Enjoy smooth travel on highways and city roads, ensuring a stress-free journey."
  },
  {
    "name": "Ertiga Cab Pune to Hyderabad",
    "description": "Affordable and convenient group travel with Ertiga cabs from Pune to Hyderabad. Choose AC/non-AC options, enjoy comfortable seating, luggage space, and professional drivers for a safe and enjoyable ride. Perfect for friends, families, or corporate groups."
  },
  {
    "name": "Luxury Cab Pune to Hyderabad",
    "description": "Travel in style with luxury cab services from Pune to Hyderabad. Premium Sedans and SUVs with elegant interiors, AC service, and professional chauffeurs make it ideal for VIP guests, business executives, or special occasions. Experience comfort, safety, and prestige throughout your journey."
  },
  {
    "name": "Affordable Cab Pune to Hyderabad",
    "description": "Get pocket-friendly Pune to Hyderabad cab services with transparent fares, AC/non-AC options, and professional drivers. Flexible timings, easy booking, and reliable service make it perfect for solo travelers, students, and small families looking for value-for-money travel."
  },
  {
    "name": "Pune to Hyderabad Outstation Cab",
    "description": "Reliable outstation cab service from Pune to Hyderabad, ideal for weekend trips, sightseeing, or long stays. Choose from a variety of vehicles, enjoy AC/non-AC comfort, flexible bookings, and safe travel with experienced drivers for a hassle-free interstate journey."
  },
  {
    "name": "Pune to Hyderabad One Way Cab",
    "description": "Book one-way cabs from Pune to Hyderabad at affordable rates. Point-to-point travel, clean vehicles, professional drivers, and flexible pickups make it ideal for travelers heading to Hyderabad without return plans."
  },
  {
    "name": "Pune to Hyderabad Drop Cab",
    "description": "One-way drop cab service from Pune to Hyderabad with flexible timings, AC/non-AC options, and professional drivers. Enjoy a smooth, comfortable ride perfect for single transfers, business trips, or leisure travel."
  },
  {
    "name": "Corporate Cab Pune to Hyderabad",
    "description": "Premium corporate cab hire from Pune to Hyderabad with executive vehicles, professional chauffeurs, and flexible travel schedules. Ideal for conferences, business meetings, client visits, and corporate events, offering comfort, punctuality, and reliability."
  },
  {
    "name": "Wedding Cab Pune to Hyderabad",
    "description": "Elegant wedding cab service from Pune to Hyderabad with luxury interiors, AC comfort, professional drivers, and on-time pickups. Perfect for bride/groom transfers, guest transport, and event logistics with complete reliability and style."
  },
  {
    "name": "Online Cab Booking Pune to Hyderabad",
    "description": "Book your Pune to Hyderabad cab online with instant confirmation, secure payment, and transparent fares. Choose from Sedans, Innova, and Ertiga for a convenient, stress-free journey. Ideal for last-minute travel, weekend trips, or planned travel with complete convenience."
  }
],
"tableData": [
  ["Pune to Hyderabad Cabs", "Pune to Hyderabad Taxi Service"],
  ["Pune to Hyderabad Car Hire", "AC Cab Pune to Hyderabad"],
  ["Non AC Cab Pune to Hyderabad", "Innova Cab Pune to Hyderabad"],
  ["Ertiga Cab Pune to Hyderabad", "Luxury Cab Pune to Hyderabad"],
  ["Affordable Cab Pune to Hyderabad", "Pune to Hyderabad Outstation Cab"],
  ["Pune to Hyderabad One Way Cab", "Pune to Hyderabad Drop Cab"],
  ["Online Cab Booking Pune to Hyderabad", "Corporate Cab Pune to Hyderabad"],
  ["Wedding Cab Pune to Hyderabad", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Hyderabad Cabs",
    "WhyChoosedescription": "Sai Trupti Cabs offers dependable and comfortable cab services from Pune to Hyderabad — ideal for business travel, family vacations, and interstate journeys."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Get affordable and clearly defined one-way or round-trip fares for Pune to Hyderabad cabs — with no hidden charges or extra costs."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, or premium vehicles to match your comfort level, travel group size, and luggage needs for the Pune–Hyderabad trip."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our skilled drivers are familiar with the Pune to Hyderabad route via Solapur Highway, ensuring a safe, smooth, and timely journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "Enjoy convenient pickups from anywhere in Pune — including airport, home, or office — and drop-offs anywhere in Hyderabad as per your preference."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "Every Sai Trupti cab is regularly serviced, sanitized, and maintained to ensure a comfortable and reliable long-distance travel experience."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated team is available round-the-clock to assist you with bookings, travel queries, or route guidance for your Pune–Hyderabad cab journey."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Hyderabad cab easily via call, WhatsApp, or our website — enjoy instant confirmation and timely cab arrival."
  }
]
























  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs offer Pune to Hyderabad cab services?',
    answer: 'Yes, Sai Trupti Cabs provides reliable and comfortable Pune to Hyderabad cab services for one way, round trips, and business or family travel.',
  },
  {
    question: 'How can I book a Pune to Hyderabad cab with Sai Trupti Cabs?',
    answer: 'You can easily book your Pune to Hyderabad cab through our website, mobile app, or by calling our 24×7 customer support team for instant booking assistance.',
  },
  {
    question: 'What types of cabs are available from Pune to Hyderabad?',
    answer: 'Sai Trupti Cabs offers a variety of vehicles including hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers, perfect for families, groups, and corporate travelers.',
  },
  {
    question: 'Are the drivers experienced for Pune to Hyderabad routes?',
    answer: 'Yes, our drivers are experienced, courteous, and well-versed with the Pune–Hyderabad highway route to ensure a safe and comfortable journey.',
  },
  {
    question: 'Can I hire a cab for sightseeing or local travel in Hyderabad?',
    answer: 'Certainly! Sai Trupti Cabs offers full-day Hyderabad sightseeing packages covering popular attractions like Charminar, Golconda Fort, Ramoji Film City, and Hussain Sagar Lake.',
  },
  {
    question: 'Is the Pune to Hyderabad cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs operates 24×7 Pune to Hyderabad cab services, so you can plan your journey anytime as per your convenience.',
  },
  {
    question: 'What are the Pune to Hyderabad cab fares?',
    answer: 'Our Pune to Hyderabad cab fares start from ₹6,500 for sedans and ₹8,000–₹9,500 for SUVs or Innova Crysta, depending on your trip type and vehicle preference.',
  },
  {
    question: 'What payment options are available for Pune to Hyderabad cab bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, and bank transfers to make your booking experience easy and secure.',
  },
  {
    question: 'What safety and hygiene measures are followed for Pune to Hyderabad cabs?',
    answer: 'All our vehicles are sanitized before each ride, and our drivers follow proper hygiene and safety protocols to ensure a safe and pleasant journey.',
  },
  {
    question: 'Is customer support available during the Pune to Hyderabad cab journey?',
    answer: 'Yes, our dedicated 24×7 customer support team is always available to assist you during your Pune to Hyderabad trip.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Reddy',
    feedback: 'We had a great Pune to Hyderabad trip with Sai Trupti Cabs. The car was very clean, and the driver was polite and professional throughout the journey.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Sneha Joshi',
    feedback: 'Sai Trupti Cabs provided excellent service for our Pune to Hyderabad travel. Smooth ride, punctual pickup, and very comfortable car!',
    rating: 5,
  },
];
























































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune to Hyderabad Cab Service",
  "image": "https://saitrupticabs.com/assets/images/pune-to-hyderabad-cab.jpg",
  "description": "Sai Trupti Cabs provides Pune to Hyderabad cab service with one way taxi, round trip cabs, Innova Crysta, Ertiga, sedan and SUV options. Book long distance outstation cabs with professional drivers, 24x7 service and safe, comfortable travel experience.",
  "provider": {
    "@type": "Organization",
    "name": "Sai Trupti Cabs",
    "url": "https://saitrupticabs.com"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Pune to Hyderabad"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8460"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "9499",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-hyderabad-cab-booking",
    "itemCondition": "https://schema.org/NewCondition"
  }
};







  return (
    <div>
<Helmet>
  <title>Pune to Hyderabad Cab Service | One Way Taxi ₹9499 | Sai Trupti Cabs</title>

  <meta 
    name="description" 
    content="Book Pune to Hyderabad cab at best price ₹9499 with Sai Trupti Cabs. One way taxi, round trip, Innova Crysta, Ertiga, sedan & SUV available. Safe, reliable and 24x7 cab service for long distance travel." 
  />

  <meta 
    name="keywords" 
    content="pune to hyderabad cab, pune to hyderabad taxi, pune to hyderabad cab service, pune to hyderabad one way cab, pune to hyderabad taxi fare, pune to hyderabad innova crysta, pune to hyderabad ertiga cab, pune to hyderabad sedan cab, cheap pune to hyderabad cab, best cab service pune to hyderabad, pune to hyderabad drop taxi, pune to hyderabad round trip cab, outstation cab pune to hyderabad, pune to hyderabad online cab booking" 
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/70.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetohyderabadcabs;